
import React from 'react';
import Layout from '@/components/layout/Layout';
import GigFilters from '@/components/gigs/GigFilters';
import UpcomingGigs from '@/components/gigs/UpcomingGigs';
import GigCalendar from '@/components/gigs/GigCalendar';
import VenueDirectory from '@/components/gigs/VenueDirectory';
import GigAnalytics from '@/components/gigs/GigAnalytics';
import CreateGigButton from '@/components/gigs/CreateGigButton';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useLocation } from 'react-router-dom';

const GigManagement: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const defaultTab = queryParams.get('tab') || 'upcoming';

  return (
    <Layout>
      <div className="container max-w-7xl mx-auto py-8 px-4">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Gig Management</h1>
          <div className="flex items-center gap-4">
            <GigFilters />
            <CreateGigButton />
          </div>
        </div>

        <Tabs defaultValue={defaultTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="upcoming">Upcoming Gigs</TabsTrigger>
            <TabsTrigger value="calendar">Calendar</TabsTrigger>
            <TabsTrigger value="venues">Venues</TabsTrigger>
            <TabsTrigger value="analytics">Analytics</TabsTrigger>
          </TabsList>
          
          <TabsContent value="upcoming">
            <UpcomingGigs />
          </TabsContent>
          
          <TabsContent value="calendar">
            <GigCalendar />
          </TabsContent>
          
          <TabsContent value="venues">
            <VenueDirectory />
          </TabsContent>
          
          <TabsContent value="analytics">
            <GigAnalytics />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default GigManagement;
